import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "../src/app/assets/scss/employees.css";
import "../src/app/assets/scss/login.css";
import "../src/app/assets/scss/recruitment.css";
import "../src/app/assets/scss/jobOpening.css";
import "../src/app/assets/scss/employeeDashboard.css";
import "../src/app/assets/scss/dashboard.css";
import "../src/app/assets/scss/scheduling.css";
import "../src/app/assets/scss/offerLetter.css";
import "../src/app/assets/scss/notification.css";
import "../src/app/assets/scss/richTextEditor.css";

import "../src/app/assets/scss/common.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
